import { useEffect, useRef, useState } from "react";
import { RetorikConfiguration } from "../configs/retorikConfig";
import { useAmn } from "../contexts/AmnContext";
import { Disposition } from "../models/dispositionEnum";

import {
  CustomVoice
  // @ts-ignore
} from '@davi/retorik-framework'
import { UserInfo } from "../models/userInfo";
import { SessionState } from "../models/sessionState";
import { handleVideoEnd } from "./DispositionHandler";
import { GetActivityCounter, sendActivity } from "../utils/globalUtils";

const EventsListener = () => {
  const amn = useAmn();
  const timerRef = useRef(amn.timer);


  useEffect(()=>{
    document.addEventListener('keydown', (event) => {
      const keyName = event.key;
    
      if (keyName === 'Control') {
        return;
      }
      if(event.ctrlKey && keyName=="*"){
        sendActivity({
          type:"event",
          name: 'continueDialog',
        });
      }
    }, false);
  },[])

  useEffect(() => {
    const handleEventListerner = (e) => {
      let customEvent: CustomEvent = e as CustomEvent;
      if (customEvent.detail) {
        console.log(customEvent.detail);

        if (customEvent.detail.name == "CHU_Event_setVoice") {
          let desiredVoice = customEvent.detail.value;
          let customVoice : CustomVoice = {
            gender: 'male',
            voice: undefined
          }
          switch (desiredVoice) {
            case "male":
              customVoice = {
                gender: 'male',
                voice: undefined
              }
              break;
          
            case "female":
              customVoice = {
                gender: 'female',
                voice: undefined
              }
              break;
            default:
              //other = voice name
              customVoice = {
                gender: undefined,
                voice: desiredVoice
              }
              break;
          }
          console.log("Set voice :", customVoice);
          let config : RetorikConfiguration | undefined = amn.retorikConfig;
          if(config){
            let changedConfig : RetorikConfiguration | undefined = {...config}
            if(changedConfig){
              changedConfig.customVoice = customVoice;
              amn.setRetorikConfig(changedConfig);
            }
          }
        }

        if (customEvent.detail.name == "CHU_Event_setUserInfo") {
            if(customEvent.detail.value?.gender && customEvent.detail.value?.voice){
              let userInfo : UserInfo = {
                gender : customEvent.detail.value.gender,
                voice : customEvent.detail.value.voice
              };
              console.log("set user info :", userInfo)
              amn.setUserInfo(userInfo);
            }
        }

        if (customEvent.detail.name == "CHU_Event_changeGender") {
          if (customEvent.detail.value == "female") {
            amn.setDisposition(Disposition.Patiente);
          } else {
            amn.setDisposition(Disposition.Enseignant);
          }
        }
        if (customEvent.detail.name == "CHU_Event_randomizeSuggestedAction") {
          amn.setRandomizeQuestions(true);
        }

        if (customEvent.detail.name == "CHU_Event_changeDisposition") {
          switch (customEvent.detail.value) {
            case "enseignant":
              amn.setDisposition(Disposition.Enseignant);
              break;
            case "patiente":
              amn.setDisposition(Disposition.Patiente);
              break;
            case "dialogueEchange":
              amn.setDisposition(Disposition.DialogueEchange);
              break;
            case "dialogueQuestionEchange":
              //Close environment selection if retreived conversation
              if(amn.retreiveConversation && amn.environmentChoice){
                amn.setEnvironmentChoice(false);
              }
              amn.setDisposition(Disposition.DialogueQuestionEchange);
              break;
            case "dialogueEchangeApprenant":
                amn.setDisposition(Disposition.DialogueEchangeApprenant);
              break;
            case "selectionEnvironnement":
              amn.setDisposition(Disposition.SelectionEnvironnement);
              break;
            case "debriefEchange":
              amn.setDisposition(Disposition.DebriefEchange);
              break;
            case "debriefEnvironnement":
              amn.setDisposition(Disposition.DebriefEnvironnement);
              break;
            default:
              break;
          }
        }

        if (customEvent.detail.name == "CHU_Event_Start_EnvironmentSelection") {
          console.log(`CHOIX DE L'ENVIRONNEMENT`);
          amn.setEnvironmentChoice(true);
        }


        if(customEvent.detail.name == "CHU_Event_ShowButtons_EnvironmentSelection"){
          amn.setShowEnvironmentChoiceButton(true);
        }

        if (customEvent.detail.name == "CHU_Event_EndSession") {
          console.log(`Fin de session`);
          amn.setSessionState(SessionState.Ended);
          localStorage.clear();
          setReturnHomeButton();
        }

        if (customEvent.detail.name == "CHU_Event_StartSession") {
          if(amn.sessionState != SessionState.Retreived){
            console.log(`Début de session`);
            amn.setSessionState(SessionState.Started);
          }
          else{
            console.log(`Reprise de session`);
          }
        }

        if (customEvent.detail.name == "CHU_Event_SetConversationId") {
          if(customEvent.detail.data){
            amn.setConversationId(customEvent.detail.data);
          }
        }

        


        //timers
        if (customEvent.detail.name == "StartTimer") {
          amn.timer.start(customEvent.detail.value);
        }
        if (customEvent.detail.name == "PauseTimer") {
          amn.timer.pause(customEvent.detail.value);
          //sendTimers();
        }
        if (customEvent.detail.name == "ResumeTimer") {
          amn.timer.resume(customEvent.detail.value);
        }
        if (customEvent.detail.name == "RetreiveHistoryTimer") {
          amn.timer.retreive();
        }
        if (customEvent.detail.name == "EraseHistoryTimer") {
          amn.timer.retreive(true);
        }
        if (
          customEvent.detail.name == "RetreiveTimer" ||
          customEvent.detail.name == "CHU_Event_GetTimer"
        ) {
          let time = amn.timer.get(customEvent.detail.value);
          console.log(amn.timer.timers);
          console.log("### TIME ### ", time);
          var intr = setInterval(function() {
            let numberOfActivityPending = GetActivityCounter()
            if(numberOfActivityPending == 0){
                sendActivity({
                  type: "event",
                  name: "CHU_Event_TimerRetreive",
                  value: { time },
                });
                clearInterval(intr);
            }
          }, 500)
          
          sendTimers();
        }
        if(customEvent.detail.name == "CHU_Event_SendTimer"){
          sendTimers();
        }
      }


      //PDF
      if (customEvent.detail.name == "ClosePDF") {
        var intr = setInterval(function() {
          let numberOfActivityPending = GetActivityCounter()
          if(numberOfActivityPending == 0){
            sendActivity({
              type: "event",
              name: "CHU_Event_ClosePDF"
            });
              clearInterval(intr);
          }
        }, 500)
       
        amn.setShowPDFButtons(false);
      }
      if (customEvent.detail.name == "OpenPDF" ||
          customEvent.detail.name == "CHU_Event_OpenPDF") {
        amn.setShowPDFButtons(true);
        console.log(customEvent.detail.value);
        if(customEvent.detail.value && customEvent.detail.value.url){
          amn.setPdfToDisplay(customEvent.detail.value.url);
        }
      }



      //Animation
      if(customEvent.detail.name == "animation"){
        console.log(customEvent.detail);
        handleVideoEnd();
      }
    };
    document.addEventListener("CHUEvent", handleEventListerner);
    return () => {
      document.removeEventListener("CHUEvent", handleEventListerner);
    };
    //document.addEventListener('CHUEvent', )
  }, [amn]);

  const sendTimers = () => {
    var intr = setInterval(function() {
      let numberOfActivityPending = GetActivityCounter()
      if(numberOfActivityPending == 0){
        sendActivity({
          type:"event",
          name: 'FormActionEvent',
          value: {
            "Type": 0,
            "Property": "Conversation.AMNACA.Timers",
            "Value":  JSON.stringify(amn.timer.timers),
            "ForceUpdateProperties": "true"
          }
        });
        clearInterval(intr);
      }
    }, 500)
    
  }

  return null;
};

const setReturnHomeButton = () =>{
  let btn_container = document.createElement("div");
  btn_container.className = "rounded bg-black bg-opacity-card text-white p-4 large:py-8 flex flex-wrap justify-around gap-3 overflow-y-auto w-full max-h-full scrollbar-thin";
  btn_container.style.order="9";
  btn_container.style.overflow="hidden";
  btn_container.id = "Button_Container"

  let btn = document.createElement("button");
  btn.innerHTML = "Revenir à l'accueil";
  btn.id = "Button_WaitForNextButton"
  btn.className = "bg-primary flex justify-self-center self-center text-black rounded p-3 m-auto mt-2 mb-2";
  
  btn.onclick = () =>{
    document.location.href="/";
  }
  btn_container.append(btn);
  document.getElementById("retorik-botResponse")?.append(btn_container);
}

export { EventsListener };
